import { render, staticRenderFns } from "./notice_regi.vue?vue&type=template&id=998dd8ce&"
import script from "./notice_regi.vue?vue&type=script&lang=js&"
export * from "./notice_regi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports